module.exports = __webpack_public_path__ + "static/img/img9.02881e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/img9.png
// module id = pWmm
// module chunks = 1